// Pages
import RouterView from '@/components/pages/RouterView/Router'

import HospitalAdmin from '@/components/pages/HospitalAdmin/HospitalAdmin.vue'
import EditHospitalAdmin from '@/components/pages/HospitalAdmin/HospitalAdminEdit.vue'

export default {
  path: '/hospital_admins',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      redirect: '/users'
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: HospitalAdmin,
          props: true,
          name: 'view-hospital-admin'
        },
        {
          path: 'edit',
          component: EditHospitalAdmin,
          name: 'edit-hospital-admin',
          props: true,
          meta: {breadcrumb: 'Edit'}
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/hospital_admin.js